import { css } from '@emotion/react'
import { breakpoints, font } from '~/base'

export const header = css`
  display: flex;
  justify-content: space-between;
  padding-top: 24px;
  flex-direction: column;
  margin-bottom: 48px;

  @media ${breakpoints.small} {
    padding-top: 44px;
    flex-direction: row-reverse;
  }
`

export const headerBrand = css`
  margin-bottom: 24px;

  @media ${breakpoints.large} {
    margin-bottom: 0;
  }
`

export const headerAction = css`
  ${font({ size: 'small' })}
  color: #a0a0a0;

  @media ${breakpoints.small} {
    padding-top: 22px;
  }

  @media ${breakpoints.large} {
    padding-top: 0;
  }
`

export const logo = css`
  display: block;
  height: 80px;
  margin-left: auto;

  @media ${breakpoints.large} {
    height: 104px;
  }
`

export const actionIcon = css`
  height: 30px;
`

export const actionButton = css`
  &:hover {
    color: var(--colors-primary);
  }
`
